module.exports = __webpack_public_path__ + "es.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/es.svg
// module id = 793
// module chunks = 0